$(document).ready(function() {
	$("#lightgallery").lightGallery({
		mode: "lg-fade",
		thumbnail: true,
		animateThumb: true,
		showThumbByDefault: true,
		keypress: true,
		selector: '.item-single',
		download: false,
		share: false,
		autoplay: false,
		progressBar: true,
		zoom: true,
		rotate: true,
		flipHorizontal: true,
		flipVertical: true,
		slideEndAnimation: true,
		hideBarsDelay: 2000,
		useLeft: true
	});

	// Update main image when thumbnail is clicked
	$('.gallery-thumbs .item-single a').on('click', function(e) {
		e.preventDefault();
		var imgSrc = $(this).find('img').attr('src');
		var fullSizeSrc = $(this).closest('.item-single').data('src');
		$('#main-product-image').attr('src', fullSizeSrc);
	});
});
